import api from '@/services/api';

const state = {
  stats: null,
  recentOrders: [],
  loading: false
};

const getters = {
  getDashboardStats: state => state.stats,
  getRecentOrders: state => state.recentOrders,
  isLoading: state => state.loading
};

const mutations = {
  SET_DASHBOARD_STATS(state, stats) {
    state.stats = stats;
  },
  SET_RECENT_ORDERS(state, orders) {
    state.recentOrders = orders;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  async getDashboardStats({ commit }) {
    try {
      commit('SET_LOADING', true);
      const response = await api.get('/dashboard');
      commit('SET_DASHBOARD_STATS', response.data);
      return response.data;
    } catch (error) {
      console.error('获取仪表盘数据失败:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getRecentOrders({ commit }) {
    try {
      const response = await api.get('/purchase-order/recent');
      commit('SET_RECENT_ORDERS', response.data);
      return response.data;
    } catch (error) {
      console.error('获取最近订单失败:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};